import request from '../../../helpers/request';

const createRoomAttachments = async (roomId, files = []) => {
  await Promise.all(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file);
      return request.post(
        `/RentPlace/rental_house/office/${roomId}/attachment`,
        formData,
        'При загрузке документа произошла ошибка'
      );
    })
  );
};

export default createRoomAttachments;
